import type { FaireProductEntity } from "../../entity_types/product";

export const p_wm54pkqmf7: FaireProductEntity = {
  token: "p_wm54pkqmf7",
  type: "product",
  name: "Grapefruit Cardamom Natural Deodorant",
  brandToken: "b_3z46kjdoak",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f138dc4960f40f0e9a2fffc3576fbfc357cff2ec772b505774c5e432f8eb3333.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/828d07f8e23034e751c587b25718fcc620ae8c7baf1e2e3a723f97a035542207.webp",
    "https://cdn.faire.com/fastly/49ef3a96c5bbaa2655deb907cf479664d57a49715081748b5e6ae6697ca8cdc8.webp",
    "https://cdn.faire.com/fastly/65e8d2e33046223af62f6a91c7a851a1e342b574fe2df72b4b4b7490cccf6442.webp",
    "https://cdn.faire.com/fastly/afdd409df74559668d925a5515b28eb9a705af5561ad9d95e14a8d942645d83e.webp",
    "https://cdn.faire.com/fastly/704755806e1aabb22699b26efa1fd680e55a8c3add5a8f6aa6fd60f030e87c7e.jpeg",
    "https://cdn.faire.com/fastly/df18f6e626dcc86c8a7d2b7fc05153879300d6cb1de7aac7142ef09ce9655aa9.jpeg",
    "https://cdn.faire.com/fastly/77026f3c7c60c7f01a5e94f22a90c7a4e73a2e0eba0b205685c64a9f9a5047f3.jpeg",
    "https://cdn.faire.com/fastly/118ea4955b8c10298b0cf2f3d2cafae33449745d44a1b91efdcab74a402b46ea.jpeg",
  ],
  priceDollars: 9,
  description:
    "Grapefruit Cardamom Natural Deodorant is a refreshing and effective solution for combating body odor. Formulated without harsh chemicals like aluminum and parabens, this deodorant provides a safe and effective alternative to conventional deodorants. Its smooth and non-greasy texture ensures easy application while also giving skin a boost of nourishment from Shea Butter and Camellia, Coconut, and Rice Bran oils. The combination of arrowroot powder, tapioca starch, baking soda, and magnesium hydroxide work together to help neutralize odor, absorb wetness, and keep you feeling dry. The result is a soft and lightweight deodorant that allows the skin to breathe naturally, leaving you feeling fresh and confident. You’ll love the naturally invigorating scents of pure Pink Grapefruit and Cardamom essential oils, which combine zesty citrus with warm woody spice.\n\nOur Natural Deodorants are made using Eco Smart® containers, making them better than ever!",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:48.952Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
